import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'account'})
export class accountPipe implements PipeTransform {
  transform(value: string): string {
    let x = value.match(/.{1,3}/g);
    if (x == null) return "";
    else return x.join(' ');
  }
}